import { InteractionCard } from "@/components/organisms/interaction";
import { SupervisorPanel } from "@/components/organisms/supervisor";
import { useResponsiveBreakpoints } from "@/hooks/responsive";

export const Supervisor = () => {
	const { isMobile } = useResponsiveBreakpoints();
	return (
		<>
			<SupervisorPanel />
			{!isMobile && <InteractionCard />}
		</>
	);
};
